import React from "react";
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg">
      <div className="text-center space-y-md">
        <h1 className="text-2xl font-semibold">Page not found</h1>
        <Link to="/" className="text-info-text hover:underline">Go home</Link>
      </div>
    </div>
  );
}
